module.exports = __webpack_public_path__ + "img/icons8-sign-up-in-calendar copy.fb178aad.svg";